import React from 'react';
import {
  FDStack, FDImage, FDPaper, FDHeadlineText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';

export const USATodayWidget = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  return (
    <FDStack paddingY={8}>
      <FDPaper appearance={'flat'} color={'info'} maxWidth={1000}>
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={4} paddingX={4} paddingY={2} alignItems={'center'}>
          {resource.withRelationship(fr.relationships.usaTodayBadge.name,
            (rel) => (
              <FDImage
                src={rel.link('related').url()}
                alt={rel.meta('altText') || ''}
                aspectRatio={rel.meta('aspectRatio')}
                width={'160px'}
                rounded={false}
              />
            ),
            () => null)}
          <FDStack direction={'column'} spacing={1}>
            {resource.attr('influencerUSATodayTitle') && <FDHeadlineText size={isMobile ? 'sm' : 'lg'} value={resource.attr('influencerUSATodayTitle')} />}
            <MetaControlField attr={'influencerUSATodayDescription'} />
          </FDStack>
        </FDStack>
      </FDPaper>
    </FDStack>
  );
};
